import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { Category } from '../models/Category';
import { AuthService } from '../modules/auth/services/auth.service';
import { CategoryService } from './category.service';
import { ProductService } from './product.service';
import { ProductSearchFilters } from '../modules/shared/classes/ProductSearchFilters';
import { NotificationsService } from './notifications.service';
import { NotificationList } from '../models/NotificationList';

@Injectable({
	providedIn: 'root'
})
export class PreloadAndMulticastService {

	private loggedUserId! : number;

	// Públicos
	private sCategories = new ReplaySubject<Category[]>(1);
	public oCategories = this.sCategories.asObservable();
	private sProductSearchFilters = new ReplaySubject<ProductSearchFilters>(1);
	public oProductSearchFilters = this.sProductSearchFilters.asObservable();
	private sNotifications = new ReplaySubject<NotificationList>(1);
	public oNotifications = this.sNotifications.asObservable();

	constructor(private auth:AuthService,
				private categoryService:CategoryService,
				private productService:ProductService,
				private notificationsService:NotificationsService) {
		this.loadPublicData();
		this.auth.oUser.subscribe(
			(u) => {
				if (u && u.id !== this.loggedUserId) {
					this.loggedUserId = u.id;
					this.loadUserDependantData();
				}
			}
		);
	}

	private loadPublicData() : void {
		this.loadCategories();
		this.loadProductFilters();
	}
	private loadUserDependantData() {
		this.loadNotifications();
	}

	//#region Public
	private loadCategories() {
		this.categoryService.getAll().subscribe({
			next: (c:Category[])=> {
				this.sCategories.next(c);
			},
		});
	}
	private loadProductFilters() {
		this.productService.getFilters().subscribe({
			next: (psf:ProductSearchFilters)=> {
				this.sProductSearchFilters.next(psf);
			}
		});
	}
	//#endregion

	//#region User dependant
	private loadNotifications() {
		this.notificationsService.latest().subscribe({
			next: (nl:NotificationList)=> {
				this.sNotifications.next(nl);
			}
		});
	}
	//#endregion
}
